export const calculateLuminance = (color: string): number => {
    // Convert hex color to RGB values
    const r: number = parseInt(color.substring(1, 3), 16);
    const g: number = parseInt(color.substring(3, 5), 16);
    const b: number = parseInt(color.substring(5, 7), 16);

    // Calculate perceived luminance using the formula Y = (2*R + B + 3*G) / 6
    return (2 * r + b + 3 * g) / 6;
};
